import api from './api';

export const getQuarterlyReview = (employeeId, year, quarterNumber) =>
  api.get('/kra/quarterly', { params: { employee_id: employeeId, year, quarter_number: quarterNumber } });

export const getQuarterlyDashboard = (year, quarterNumber, departmentId) =>
  api.get('/kra/quarterly/dashboard', {
    params: { year, quarter_number: quarterNumber, ...(departmentId ? { department_id: departmentId } : {}) },
  });

export const submitCalibration = (data) => api.post('/kra/quarterly/calibration', data);

export const getKraAuditLog = (params = {}) => api.get('/kra/audit', { params });
